import { useState } from 'react';
import { Link } from 'react-router-dom';
import TeamBadge from '@/components/base/TeamBadge';
import { allStandings, getTeam } from '@/utils/data';

export default function StandingsCard() {
  const [active, setActive] = useState(allStandings[0]?.leagueId || 'nba');
  const standing = allStandings.find((s) => s.leagueId === active) || allStandings[0];

  return (
    <section className="bg-background-50 border border-background-200/80 rounded-lg overflow-hidden">
      <header className="flex items-center justify-between px-4 md:px-5 py-3 border-b border-background-200/80 bg-background-100/60">
        <h2 className="flex items-center gap-2 font-heading font-bold text-base md:text-lg text-foreground-950">
          <span className="w-6 h-6 flex items-center justify-center text-accent-600">
            <i className="ri-trophy-line"></i>
          </span>
          排名榜单
        </h2>
        <Link to={`/category/${active}`} className="flex items-center gap-1 text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
          查看全部
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </header>

      <div className="flex items-center gap-1 px-3 md:px-4 pt-3 flex-wrap">
        {allStandings.map((s) => (
          <button
            key={s.leagueId}
            type="button"
            onClick={() => setActive(s.leagueId)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
              active === s.leagueId ? 'bg-secondary-500 text-background-50' : 'bg-background-100 text-foreground-600 hover:text-primary-600'
            }`}
          >
            {s.leagueName}
          </button>
        ))}
      </div>

      <div className="px-3 md:px-4 py-2">
        <div className="grid grid-cols-[28px_1fr_60px_52px] items-center gap-2 py-2 text-[10px] md:text-xs text-foreground-500 border-b border-background-200/70">
          <span>名次</span>
          <span>球队</span>
          <span className="text-center">胜/负</span>
          <span className="text-right">胜率</span>
        </div>
        {standing?.rows.map((row) => {
          const team = getTeam(row.teamId);
          return (
            <Link
              key={row.teamId}
              to={`/team/${row.teamId}`}
              className="grid grid-cols-[28px_1fr_60px_52px] items-center gap-2 py-2.5 border-b border-background-200/50 last:border-b-0 hover:bg-primary-50/60 rounded-md px-1 -mx-1 transition-colors cursor-pointer"
            >
              <span className={`font-heading font-bold text-sm ${row.rank <= 3 ? 'text-primary-600' : 'text-foreground-500'}`}>{row.rank}</span>
              <span className="flex items-center gap-2 min-w-0">
                <TeamBadge team={team} size="sm" />
                <span className="text-sm text-foreground-800 truncate">{team?.name}</span>
              </span>
              <span className="text-center text-xs md:text-sm text-foreground-700 tabular-nums">{row.win}/{row.loss}</span>
              <span className="text-right text-xs md:text-sm text-foreground-700 tabular-nums">{row.winRate}</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}